import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useReactToPrint } from "react-to-print";
import {
  Box,
  Input,
  Table,
  TableCaption,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Button,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Checkbox,
  FormLabel,
  useToast,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Select,
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import EditQuickBillModal from "./quickBillEditModal";
import { set } from "lodash";
import { numberToWords } from "../utils/numberToWords";
import Cookie from "js-cookie";
import QuickBillPrintModal from "./quickBillPrintModal";
import ServerTipModal from "./serverTipModal";

const QuickBillData = () => {
  const {
    isOpen: isTipOpen,
    onOpen: onTipOpen,
    onClose: onTipClose,
  } = useDisclosure();
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const {
    isOpen: isPrintOpen,
    onOpen: onPrintOpen,
    onClose: onPrintClose,
  } = useDisclosure();

  const cancelRef = useRef();
  const [isOpen1, setIsOpen] = useState(false);
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState([]);
  const [editItemId, setEditItemId] = useState(null);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [printData, setPrintData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedBills, setSelectedBills] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const customerId = localStorage.getItem("customerId");
  const componentRef = useRef();
  const handlePrint1 = useReactToPrint({
    content: () => componentRef.current,
  });
  const handlePrintModal = () => {
    onPrintOpen();
  };
  const token = Cookie.get("token");

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getQuickBillDataByDate/${customerId}?startDate=${startDate}&endDate=${endDate}`,
      );

      const updatedOrders = response.data.quickBill.map((order) => ({
        ...order,
        tax: Math.round(order.cgst + order.sgst), // 👈 add tax field
      }));

      setData(updatedOrders);
      setFilteredData(updatedOrders);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    }
  };

  const dueData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getDueBill/${customerId}?startDate=${startDate}&endDate=${endDate}`,
      );

      const updatedOrders = response.data.quickBill.map((order) => ({
        ...order,
        tax: Math.round(order.cgst + order.sgst),
      }));

      setData(updatedOrders);
      setFilteredData(updatedOrders);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while fetching data.");
      }
    }
  };

  const ncData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getNcBill/${customerId}?startDate=${startDate}&endDate=${endDate}`,
      );

      const updatedOrders = response.data.quickBill.map((order) => ({
        ...order,
        tax: Math.round(order.cgst + order.sgst),
      }));

      setData(updatedOrders);
      setFilteredData(updatedOrders);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while fetching data.");
      }
    }
  };

  const fetchEditData = async (id) => {
    try {
      console.log("Fetching bill with ID:", id); // Log the ID being fetched

      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getQuickBillData/${customerId}/${id}`,
      );

      console.log("Full API response:", response);
      console.log("Quick bill data:", response.data.quickBill); // Log specific part of response

      setEditData(response.data.quickBill);
      setEditItemId(id);
      onEditOpen();
    } catch (error) {
      console.error("Error fetching bill data:", error); // Log full error
      toast.error("No Bill found By this specific Id");
    }
  };

  const fetchTipData = async (id) => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getQuickBillData/${customerId}/${id}`,
      );
      setEditData(response.data.quickBill);
      setEditItemId(id);
      onTipOpen();
    } catch (error) {
      toast.error("No Bill found By this specific Id");
    }
  };

  const fetchData3 = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getPrintData/${customerId}`,
      );
      const rooms = response.data;

      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(
              `https://api.rasoi.launchlysoftware.in/get-image/${room.image}`,
              {
                responseType: "blob", // Assuming image is returned as a blob
              },
            );

            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        }),
      );
      console.log(updatedRooms, "updatedRooms");
      setPrintData(updatedRooms);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handlePayment = async (id) => {
    try {
      const response = await axios.put(
        `https://api.rasoi.launchlysoftware.in/api/updatePayment/${customerId}/${id}`,
      );
      alert(response.data.message);
      window.location.reload("/quickBillData");
    } catch (error) {
      toast.error(error);
    }
  };
  const itemsPerPage = 100; // or any number you prefer
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };
  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);
  useEffect(() => {
    // fetchData();
    fetchData3();
  }, [customerId]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    filterData(event.target.value, startDate, endDate);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
    filterData(searchTerm, event.target.value, endDate);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
    filterData(searchTerm, startDate, event.target.value);
  };

  const filterData = (term, start, end) => {
    let filtered = data.filter((order) => {
      const orderDate = new Date(order.createdAt).getTime();
      const startFilter = start ? new Date(start).getTime() : null;
      const endFilter = end ? new Date(end).getTime() : null;

      if (!term && !startFilter && !endFilter) {
        return true; // No filters applied, return all data
      }

      const matchesTerm = term
        ? order.name.toLowerCase().includes(term.toLowerCase()) ||
          order.phoneNo.includes(term) // Include phone number in search
        : true; // If no term, treat it as true

      const withinDateRange =
        (!startFilter || orderDate >= startFilter) &&
        (!endFilter || orderDate <= endFilter);

      return matchesTerm || !term; // If no term, skip term filtering, only use date range
    });

    setFilteredData(filtered);
  };
  const handleEdit = (itemId) => {
    setEditItemId(itemId);
    fetchEditData();
    onEditOpen();
  };
  const handleCheckboxChange = (billId, checked) => {
    if (checked) {
      setSelectedBills((prev) => [...prev, billId]);
    } else {
      setSelectedBills((prev) => prev.filter((id) => id !== billId));
    }
  };
  const handlePrint = (order) => {
    let total = numberToWords(
      order.gst === false
        ? order.foodItem.reduce((acc, item) => acc + item.price, 0) * 0.05 +
            order.wineItem.reduce((acc, item) => acc + item.price, 0) +
            order.foodItem.reduce((acc, item) => acc + item.price, 0)
        : order.wineItem.reduce((acc, item) => acc + item.price, 0) +
            order.foodItem.reduce((acc, item) => acc + item.price, 0),
    );
    const content = `
    <html>
      <head>
       <style>
  body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0.2in;
    width: 3in;
   
   
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 10px;
  }
    @page{size: 3in auto; 
            margin: 1;
            margin-bottom: 10;
            padding:1
}
  th, td {
    border-bottom: 1px dashed black;
    text-align: left;
    padding: 2px;
    font-size: 10px;
  }
  th {
    background-color: #f2f2f2;
  }
  h4, h5 {
    text-align: center;
    margin: 4px 0;
    font-size: 12px;
  }
  .center {
    text-align: center;
    margin-bottom: 10px;
  }
  .footer {
    text-align: right;
    margin-top: 10px;
    font-size: 12px;
  }
  .left {
    font-size: 10px;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    border-bottom: 1px dashed black;
  }
  .Grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 7px;
    place-items: center;
  }
  .summary {
    margin-top: 10px;
    font-size: 12px;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-end;
    border-bottom: 1px dashed black;
    padding: 6px;
  }
  img {
    width: 90px;
    height: 60px;
    border-radius: 8px;
    display: block;
    margin: 0 auto;
  }
  @media print {
    body {
      margin: 0;
      padding: 0;
    }
    table, .center, .summary, .footer {
      page-break-inside: avoid;
    }
  }
</style>
      </head>
      <body>
        ${printData
          .map(
            (item) => `
          <div class="center">
            <h4>Cash Memo</h4>
            <img src="${item.imageUrl}" alt="Logo" />
            <h4><b>${item.name}</b></h4>
            <h5>${item.adress}</h5>
            <h5>Phone: ${item.phoneNo}</h5>
            <h5>${item.website}</h5>
            ${item.gstNo ? `<h5>GST No: ${item.gstNo}</h5>` : ""}
            ${item.fssaiNo ? `<h5>FSSAI No: ${item.fssaiNo}</h5>` : ""}
          </div>
        `,
          )
          .join("")}
        <div class="Grid">
        <h4>Table:${order.tableNo}</h4>
        <h4>Bill:${order.billNo}</h4>
        
        
        
        </div>
        <div>
        <h4>Date:${new Date(order.createdAt).toLocaleString("en-GB")}</h4>
        </div>
        
        ${
          order.wineItem.length > 0
            ? `
          <h4 class="center"># Wine Items #</h4>
          <table>
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Rate</th>
                <th>Qty</th>
                
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              ${order.wineItem
                .map(
                  (item) => `
                <tr>
                  <td>${item.name}</td>
                  <td>${(item.price / item.quantity).toFixed(2)}</td>
                  <td>${item.quantity}</td>
                  
                  <td>${item.price}</td>
                </tr>
              `,
                )
                .join("")}
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5" class="footer">Gross Total: ${order.wineItem.reduce(
                  (acc, item) => acc + item.price,
                  0,
                )}</td>
              </tr>
              <tr>
                <td colspan="5" class="footer">Drinks Total: ${order.wineItem.reduce(
                  (acc, item) => acc + item.price,
                  0,
                )}</td>
              </tr>
            </tfoot>
          </table>
        `
            : ""
        }

         <h4 class="center"># Food Items #</h4>
  <table>
    <thead>
      <tr>
        <th>Item Name</th>
        ${order.cgst > 0 ? `<th>Hsn/Sac</th>` : ""}
        <th>Rate</th>
        <th>Qty</th>
        <th>Amount</th>
      </tr>
    </thead>
    <tbody>
      ${order.foodItem
        .map(
          (item) => `
        <tr>
          <td>${item.name}</td>
          ${order.cgst > 0 ? `<td>${item.hsnNo || ""}</td>` : ""}
          <td>${(item.price / item.quantity).toFixed(2)}</td>
          <td>${item.quantity}</td>
          <td>${item.price.toFixed(2)}</td>
        </tr>
      `,
        )
        .join("")}
    </tbody>
    <tfoot>
      <tr>
        <td colspan="5" class="footer">
          Gross Total: ₹${order.foodItem
            .reduce((acc, item) => acc + item.price, 0)
            .toFixed(2)}
        </td>
      </tr>
      <tr>
        <td colspan="5" class="footer">
          Add  CGST on Gross: ₹${
            order.cgst > 0 ? order.cgst.toFixed(2) : "0.00"
          }
        </td>
      </tr>
      <tr>
        <td colspan="5" class="footer">
          Add  SGST on Gross: ₹${
            order.cgst > 0 ? order.sgst.toFixed(2) : "0.00"
          }
        </td>
      </tr>
      <tr>
        <td colspan="5" class="footer">
          5% Total GST: ₹${
            order.cgst > 0 ? (order.cgst + order.sgst).toFixed(2) : "0.00"
          }
        </td>
      </tr>
      <tr>
        <td colspan="5" class="footer">
          Food Total: ₹${
            order.cgst > 0
              ? (
                  order.cgst * 2 +
                  order.foodItem.reduce((acc, item) => acc + item.price, 0)
                ).toFixed(2)
              : order.foodItem
                  .reduce((acc, item) => acc + item.price, 0)
                  .toFixed(2)
          }
        </td>
      </tr>
    </tfoot>
  </table>
        <div class="summary">
        <h4 class="center">Net Gross Total Amount ${
          order.wineItem.reduce((acc, item) => acc + item.price, 0) +
          order.foodItem.reduce((acc, item) => acc + item.price, 0)
        }</h4>
        <h4 class="center">5% GST Total ${
          order.cgst > 0 ? order.cgst * 2 : 0
        }</h4>
       ${
         order.discountPercentage
           ? `<h4 class="center">Discount Precentage-${order.discountPercentage}</h4>`
           : ""
       }
       ${
         order.discount
           ? `<h4 class="center">Discount-${order.discount}</h4>`
           : ""
       }

       ${
         order.cgst > 0
           ? ` <h5 class="center">Roundoff- ${
               parseInt(order.totalBilling) -
               (parseInt(
                 order.wineItem.reduce((acc, item) => acc + item.price, 0),
               ) +
                 parseInt(
                   order.foodItem.reduce((acc, item) => acc + item.price, 0),
                 ) +
                 order.cgst * 2)
             }</h5>`
           : ""
       }
       
        <h4 class="center">Total Amount ${order.totalBilling}</h4>
       
          

        </div>
        <div class='left'>
        <h4 >Total Amount (INR in words): ${total}</h4>
        </div>
        
       ${order.cash ? `<h4 class="center">Cash : ${order.cash}</h4>` : ""}
       ${
         order.online
           ? `<h4 class="center">${order.mode} : ${order.online}</h4>`
           : ""
       }

        <div class="footer">
        <h5>Thank you</h5>
        <h5>Visit Again</h5>
        </div>

        <script>
          window.onload = () => window.print();
        </script>
      </body>
    </html>
  `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(content);
    printWindow.document.close();
  };

  const exportToExcel = () => {
    const cleanedData = filteredData.map((order) => {
      // Extract Food and Wine totals separately
      const foodAmount = order.foodItem?.reduce(
        (sum, item) => sum + (item.price || 0) * (item.quantity || 0),
        0,
      );

      const wineAmount = order.wineItem?.reduce(
        (sum, item) => sum + (item.price || 0) * (item.quantity || 0),
        0,
      );

      // Example tax fields (replace with your actual values from API/db)
      const cgst = order.cgst || 0;
      const sgst = order.sgst || 0;
      const discount = order.discountPercentage || 0;
      const roundOff = order.roundOff || 0;

      // Gross Bill before discount/roundoff
      const billAmount = (foodAmount || 0) + (wineAmount || 0) + cgst + sgst;

      // Net amount after adjustments
      const netAmount = billAmount - discount + roundOff;

      return {
        Date: new Date(order.createdAt).toLocaleDateString("en-GB"),
        BillNo: order.billNo,
        BillAmount: billAmount,
        FoodAmount: foodAmount,
        WineAmount: wineAmount,
        CGST: cgst,
        SGST: sgst,
        "Discount(%)": discount,
        RoundOff: roundOff,
        NetAmount: netAmount,
      };
    });

    // Create worksheet & workbook
    const worksheet = XLSX.utils.json_to_sheet(cleanedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bill Report");

    // Save as file
    XLSX.writeFile(workbook, `${startDate}-${endDate}-BillData.xlsx`);
  };
  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `https://api.rasoi.launchlysoftware.in/api/deleteQuickBill/${customerId}/${deleteItemId}?customerId=${customerId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      toast.success(response.data.message);
      setIsOpen(false);
      fetchData();
    } catch (error) {
      if (error.response.status === 403) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response.data.message);
      }
    }
  };
  const openModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose1 = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };
  const grandTotal = currentItems.reduce(
    (sum, order) => sum + (order.totalBilling || 0),
    0,
  );

  return (
    <Box p={6} bg="gray.50" minH="90vh">
      <Box
        mb={6}
        display="flex"
        flexWrap="wrap"
        gap={3}
        p={4}
        bg="white"
        borderRadius="lg"
        boxShadow="md"
      >
        <Input
          flex="1"
          minW="200px"
          type="text"
          placeholder="Search by Name or Phone"
          value={searchTerm}
          onChange={handleSearchChange}
          bg="white"
        />
        <Input
          w="180px"
          type="date"
          placeholder="Start Date"
          value={startDate}
          onChange={handleStartDateChange}
          bg="white"
        />
        <Input
          w="180px"
          type="date"
          placeholder="End Date"
          value={endDate}
          onChange={handleEndDateChange}
          bg="white"
        />
        <Input
          w="180px"
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          bg="red.400"
          color="white"
          placeholder="Update Date"
          _hover={{ bg: "red.500" }}
          _focus={{ bg: "red.300" }}
        />

        <Button
          colorScheme="blue"
          onClick={async () => {
            try {
              if (!selectedBills.length) {
                toast.error("Please select at least one bill");
                return;
              }
              if (!selectedDate) {
                toast.error("Please select a date");
                return;
              }

              const response = await axios.put(
                `https://api.rasoi.launchlysoftware.in/api/updateBillsDate/${customerId}`,
                {
                  billIds: selectedBills,
                  newDate: selectedDate,
                },
              );

              toast.success(response.data.message);
              fetchData();
            } catch (error) {
              toast.error(error.response?.data?.message || "Update failed");
            }
          }}
        >
          Update Bill Date
        </Button>
        <Button colorScheme="green" onClick={dueData}>
          Due Bills
        </Button>
        <Button colorScheme="yellow" onClick={ncData}>
          NC Bills
        </Button>
        <Button colorScheme="blue" onClick={handlePrintModal}>
          Print
        </Button>
        <Button colorScheme="teal" onClick={exportToExcel}>
          Export Excel
        </Button>
      </Box>

      <EditQuickBillModal
        data={editData}
        onOpen={onEditOpen}
        onClose={onEditClose}
        isOpen={isEditOpen}
        customerId={customerId}
        setSelectId={setEditItemId}
        id={editItemId}
      />
      <ServerTipModal
        data={editData}
        onOpen={onTipOpen}
        onClose={onTipClose}
        isOpen={isTipOpen}
        customerId={customerId}
        setSelectId={setEditItemId}
        id={editItemId}
      />
      <TableContainer
        width="full"
        bg="white"
        borderRadius="lg"
        boxShadow="md"
        maxH="calc(100vh - 280px)"
        overflowY="auto"
      >
        <Table size="sm" variant="simple">
          <TableCaption placement="top" fontSize="lg" fontWeight="bold" mb={2}>
            Quick Bill Data
          </TableCaption>
          <Thead position="sticky" top={0} bg="green.500" zIndex={1}>
            <Tr>
              <Th color="white">Food Items</Th>
              <Th color="white">Wine Items</Th>
              <Th color="white">Name</Th>
              <Th color="white">Phone No</Th>
              <Th color="white">Bill No</Th>
              <Th color="white">Table No</Th>
              <Th color="white" isNumeric>
                Total Bill
              </Th>
              <Th color="white" isNumeric>
                GST
              </Th>
              <Th color="white" isNumeric>
                Discount
              </Th>
              <Th color="white" isNumeric>
                Discount %
              </Th>
              <Th color="white" isNumeric>
                Happy Discount %
              </Th>
              <Th color="white" isNumeric>
                Wine Discount %
              </Th>
              <Th color="white" isNumeric>
                Food Discount %
              </Th>
              <Th color="white">Complementary</Th>
              <Th color="white" isNumeric>
                Gross Amount
              </Th>
              <Th color="white" isNumeric>
                Cash
              </Th>
              <Th color="white" isNumeric>
                Card
              </Th>
              <Th color="white">Mode</Th>
              <Th color="white" isNumeric>
                Online
              </Th>
              <Th color="white" isNumeric>
                Due
              </Th>
              <Th color="white">Created At</Th>
              <Th color="white">Server Name</Th>
              <Th color="white" isNumeric>
                Tip
              </Th>
              <Th color="white">Select</Th>
              <Th color="white">Print</Th>
              <Th color="white">Edit</Th>
              <Th color="white">Add Tip</Th>
              <Th color="white">Delete</Th>
            </Tr>
          </Thead>
          <Tbody>
            {currentItems.map((order, index) => (
              <Tr key={index}>
                <Td py={3}>
                  <Box
                    maxH="300px"
                    overflowY="auto"
                    bg="orange.50"
                    borderRadius="md"
                    p={2}
                  >
                    <Table size="sm" variant="simple">
                      <Thead
                        position="sticky"
                        top={0}
                        bg="orange.400"
                        zIndex={1}
                      >
                        <Tr>
                          <Th color="white" fontSize="xs">
                            Name
                          </Th>
                          {order.cgst > 0 ? (
                            <Th color="white" fontSize="xs">
                              HSN No
                            </Th>
                          ) : null}
                          <Th color="white" fontSize="xs" isNumeric>
                            Qty
                          </Th>
                          <Th color="white" fontSize="xs" isNumeric>
                            Price
                          </Th>
                          <Th color="white" fontSize="xs" isNumeric>
                            SGST
                          </Th>
                          <Th color="white" fontSize="xs" isNumeric>
                            CGST
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {order.foodItem.map((item, idx) => (
                          <Tr key={idx}>
                            <Td fontSize="sm">{item.name}</Td>
                            {order.cgst > 0 ? (
                              <Td fontSize="sm">{item.hsnNo}</Td>
                            ) : null}
                            <Td fontSize="sm" isNumeric>
                              {item.quantity}
                            </Td>
                            <Td fontSize="sm" isNumeric>
                              ₹{item.price}
                            </Td>
                            <Td fontSize="sm" isNumeric>
                              ₹{item.sgst?.toFixed(1)}
                            </Td>
                            <Td fontSize="sm" isNumeric>
                              ₹{item.cgst?.toFixed(1)}
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </Box>
                </Td>
                <Td py={3}>
                  <Box
                    maxH="300px"
                    overflowY="auto"
                    bg="yellow.50"
                    borderRadius="md"
                    p={2}
                  >
                    <Table size="sm" variant="simple">
                      <Thead
                        position="sticky"
                        top={0}
                        bg="yellow.400"
                        zIndex={1}
                      >
                        <Tr>
                          <Th color="white" fontSize="xs">
                            Name
                          </Th>
                          <Th color="white" fontSize="xs" isNumeric>
                            Qty
                          </Th>
                          <Th color="white" fontSize="xs" isNumeric>
                            Price
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {order.wineItem.map((item, idx) => (
                          <Tr key={idx}>
                            <Td fontSize="sm">{item.name}</Td>
                            <Td fontSize="sm" isNumeric>
                              {item.quantity}
                            </Td>
                            <Td fontSize="sm" isNumeric>
                              ₹{item.price}
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </Box>
                </Td>
                <Td py={3}>{order.name}</Td>
                <Td py={3}>{order.phoneNo}</Td>
                <Td py={3}>{order.billNo}</Td>
                <Td py={3}>{order.tableNo}</Td>
                <Td py={3} isNumeric fontWeight="semibold">
                  ₹{order.totalBilling}
                </Td>
                <Td py={3} isNumeric>
                  ₹{order.tax}
                </Td>
                <Td py={3} isNumeric>
                  ₹{order.discount}
                </Td>
                <Td py={3} isNumeric>
                  {order.discountPercentage}%
                </Td>
                <Td py={3} isNumeric>
                  {order.happyHourDiscountPercentage > 0
                    ? `${order.happyHourDiscountPercentage}%`
                    : "-"}
                </Td>
                <Td py={3} isNumeric>
                  {order.wineDiscount}%
                </Td>
                <Td py={3} isNumeric>
                  {order.foodDiscount}%
                </Td>
                <Td py={3}>{order.isComplementary ? "Yes" : "No"}</Td>
                <Td py={3} isNumeric>
                  ₹{order.grossAmount}
                </Td>
                <Td py={3} isNumeric>
                  ₹{order.cash}
                </Td>
                <Td py={3} isNumeric>
                  ₹{order.card}
                </Td>
                <Td py={3}>{order.mode}</Td>
                <Td py={3} isNumeric>
                  ₹{order.online}
                </Td>
                <Td py={3} isNumeric>
                  ₹{order.due}
                </Td>
                <Td py={3}>
                  {new Date(order.createdAt).toLocaleString("en-GB")}
                </Td>
                <Td py={3}>{order.server}</Td>
                <Td py={3} isNumeric>
                  ₹{order.serverTip}
                </Td>
                <Td py={3}>
                  <Checkbox
                    isChecked={selectedBills.includes(order._id)}
                    onChange={(e) =>
                      handleCheckboxChange(order._id, e.target.checked)
                    }
                    colorScheme="red"
                  />
                </Td>
                <Td py={3}>
                  <Button
                    colorScheme="blue"
                    size="sm"
                    onClick={() => handlePrint(order)}
                  >
                    Print
                  </Button>
                </Td>
                <Td py={3}>
                  <Button
                    colorScheme="green"
                    size="sm"
                    onClick={() => fetchEditData(order._id)}
                  >
                    Edit
                  </Button>
                </Td>
                <Td py={3}>
                  <Button
                    colorScheme="teal"
                    size="sm"
                    onClick={() => fetchTipData(order._id)}
                  >
                    Add Tip
                  </Button>
                </Td>
                <Td py={3}>
                  <Button
                    colorScheme="red"
                    size="sm"
                    onClick={() => openModal(order._id)}
                  >
                    Delete
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      <Box
        mt={4}
        p={4}
        bg="white"
        borderRadius="lg"
        boxShadow="md"
        textAlign="center"
      >
        <Box fontWeight="bold" fontSize="xl" color="green.600">
          Grand Total: ₹{grandTotal.toFixed(2)}
        </Box>
      </Box>
      <AlertDialog
        isOpen={isOpen1}
        leastDestructiveRef={cancelRef}
        onClose={onClose1}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this item?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose1}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <QuickBillPrintModal
        isOpen={isPrintOpen}
        onOpen={onPrintOpen}
        onClose={onPrintClose}
        data={printData}
        quickBillData={filteredData}
      />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mt={6}
        gap={2}
      >
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
          size="sm"
          colorScheme="blue"
          variant="outline"
        >
          Previous
        </Button>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            onClick={() => handlePageChange(i + 1)}
            variant={currentPage === i + 1 ? "solid" : "outline"}
            size="sm"
            colorScheme="blue"
          >
            {i + 1}
          </Button>
        ))}
        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
          size="sm"
          colorScheme="blue"
          variant="outline"
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default QuickBillData;
